<template>
  <v-btn
    class="mx-2"
    small
    color="transparent"
    elevation="2"
    @click="$emit('input', !value)"
    >{{ value ? hideText : showText }}</v-btn
  >
</template>

<script>
export default {
  props: {
    value: {
      type: Boolean,
      required: true
    },
    showText: {
      type: String,
      default: "Show"
    },
    hideText: {
      type: String,
      default: "Hide"
    }
  }
};
</script>
